import { FunctionComponent, MouseEvent } from 'react'
import styled, { useTheme } from 'styled-components'
import SvgIcon from '@components/SvgIcon'
import translate from '@i18n'

interface MenuCloseIconProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
}

const IconWrapper = styled.button`
  text-align: right;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
  line-height: 0;
`

const MenuCloseIcon: FunctionComponent<MenuCloseIconProps> = ({
  onClick,
  className,
}) => {
  const theme = useTheme()
  return (
    <IconWrapper aria-label={translate('close')} onClick={onClick}>
      <SvgIcon
        className={className}
        iconName="navigation-close"
        size={23}
        color={theme.colors.brandColors.brand_55}
      />
    </IconWrapper>
  )
}

export default MenuCloseIcon
